var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrometheon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4492C0 4.92637 4.47715 0.449219 10 0.449219H38C43.5229 0.449219 48 4.92637 48 10.4492V38.4492C48 43.9721 43.5228 48.4492 38 48.4492H10C4.47715 48.4492 0 43.9721 0 38.4492V10.4492Z",
    fill: "url(#paint0_linear_4168_5919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 14.4492V20.4492C26.0003 20.7847 26.0846 21.1148 26.2455 21.4092L31.7555 31.4892C31.9221 31.7938 32.0066 32.1366 32.0006 32.4837C31.9946 32.8309 31.8984 33.1705 31.7213 33.4692C31.5442 33.7679 31.2924 34.0153 30.9907 34.1871C30.6889 34.359 30.3477 34.4493 30.0005 34.4492H18.0005C17.6532 34.4493 17.312 34.359 17.0103 34.1871C16.7085 34.0153 16.4567 33.7679 16.2797 33.4692C16.1026 33.1705 16.0063 32.8309 16.0003 32.4837C15.9943 32.1366 16.0788 31.7938 16.2455 31.4892L21.7555 21.4092C21.9164 21.1148 22.0006 20.7847 22.0005 20.4492V14.4492",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4531 27.4492H29.5471",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.4492H27.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5919",
    x1: 24,
    y1: 0.449219,
    x2: 24,
    y2: 48.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrometheon);
export default __webpack_public_path__ + "static/media/prometheon.a410a214ae28a9efd0f0b9be637f5889.svg";
export { ForwardRef as ReactComponent };